<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />

    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <div v-if="dataretrived ">
      <div v-if="!AppSuccessInvest">
        <v-layout wrap justify-space-around>
          <v-flex xs12 sm12 md6 text-center pt-4>
            <span style="font-size:24px;font-weight:600;">Terms of Investment</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-around>
          <v-flex xs12 sm12 md6 text-center pt-2>
            <span style="font-size:20px;font-weight:800;">{{projectData.name}}</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-around>
          <v-flex xs12 sm12 md6 text-center pt-2 px-4>
            <span v-html="projectData.shortDescription" style="font-size:16px;font-weight:400;"></span>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-space-around>
			<v-flex xs12 sm12 md6 text-center pt-2>
				<span style="font-size:20px;font-weight:500;">Securities up for investment</span>
			</v-flex>
        </v-layout>-->
        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md3 pt-4 px-6>
            <v-card>
              <v-layout wrap>
                <v-flex pt-4 px-4 xs12 sm12 md12 text-left>
                  <span style="font-size:16px;font-weight:400;">Bank Accounts</span>
                </v-flex>
              </v-layout>
              <div v-if="banks.length>0">
                <v-radio-group v-model="bankAccount">
                  <v-layout v-for="(item,i) in banks" :key="i" wrap>
                    <v-flex px-4 pb-2>
                      <v-radio :value="item" color="#26af82" :ripple="false">
                        <template v-slot:label>
                          <span
                            style="font-size:14px;font-weight:500;"
                          >{{item.AccountNumber}} - {{item.BankCode}}</span>
                        </template>
                      </v-radio>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </div>
              <div v-else>
                <v-layout wrap>
                  <v-flex text-center>
                    <span style="font-size:12px;font-weight:400;">No Accounts Added</span>
                  </v-flex>
                </v-layout>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 sm12 md3 pt-4 px-6>
            <v-card>
              <v-layout wrap>
                <v-flex pt-4 px-4 xs12 sm12 md12 text-left>
                  <span style="font-size:16px;font-weight:400;">Bank Account Details</span>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-start>
                <v-flex md12 px-4 pt-2>
                  <v-text-field
                    ref="bank"
                    :rules="[rules.required]"
                    v-model="bank"
                    label="Bank"
                    color="#26af82"
                    required
                  ></v-text-field>
                  <v-text-field
                    ref="accountHolder"
                    :rules="[rules.required]"
                    v-model="accountHolder"
                    label="Account Holder"
                    color="#26af82"
                    required
                  ></v-text-field>
                  <v-text-field
                    ref="accountNo"
                    :rules="[rules.required]"
                    v-model="accountNo"
                    label="Account Number"
                    color="#26af82"
                    required
                  ></v-text-field>
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 sm12 md6 pr-2>
                      <v-text-field
                        ref="bankCode"
                        :rules="[rules.required]"
                        v-model="bankCode"
                        label="Bank Code"
                        color="#26af82"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        ref="branch"
                        :rules="[rules.required]"
                        v-model="branch"
                        label="Branch"
                        color="#26af82"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm12 md4 pt-4>
            <v-layout wrap justify-center>
              <v-flex md12 px-3>
                <v-card>
                  <v-layout>
                    <v-flex xs12 sm12 md12 px-4 pt-4>
                      <span style="font-size:16px;font-weight:400;">Payment Summary / Subscribtion</span>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6 sm6 md6 px-4 text-left>
                      <span style="font-size:12px;font-weight:400;color:#1FB07C">Subscribtion Amount</span>
                    </v-flex>
                    <v-flex xs6 sm6 md6 px-8 text-left>
                      <span style="font-size:12px;font-weight:400;color:#1FB07C">Value at Maturity</span>
                    </v-flex>
                  </v-layout>
                  <v-divider />
                  <v-layout
                    px-2
                    pt-4
                    wrap
                    justify-space-around
                    v-for="(item,i) in subscribtion"
                    :key="i"
                  >
                    <v-flex>
                      <v-layout>
                        <v-flex xs2 sm2 md2 align-self-center>
                          <v-checkbox
                            color="#1FB07C"
                            :ripple="false"
                            v-model="item.isSelected"
                            dense
                            class="subcheckbox"
                          >
                            <template v-slot:label>
                              <span style="font-size:14px;font-weight:500;">{{item.percentage}}%</span>
                            </template>
                          </v-checkbox>
                        </v-flex>

                        <v-flex xs10 sm6 md5 px-2 align-self-center>
                          <v-text-field
                            v-model="item.amount"
                            :label="item.name"
                            prepend-inner-icon="mdi-currency-usd"
                            color="#26af82"
                            dense
                            required
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm4 md5 align-self-center>
                          <v-text-field
                            v-model="item.maturity"
                            :label="item.name"
                            readonly
                            prepend-inner-icon="mdi-currency-usd"
                            color="#26af82"
                            style="font-weight:500"
                            solo
                            dense
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-divider />
                    </v-flex>
                  </v-layout>

                  <v-layout pt-4 px-2 wrap justify-center>
                    <v-flex xs12 sm6 md6 text-center pt-3>
                      <span style="font-size:14px;font-weight:400;">Total Invested Amount</span>
                    </v-flex>
                    <v-flex xs12 sm6 md6 px-4>
                      <v-text-field
                        ref="investmentTotal"
                        v-model="investmentTotal"
                        solo
                        style="font-weight:500"
                        readonly
                        prepend-inner-icon="mdi-currency-usd"
                        color="#26af82"
                        dense
                        :error-messages="msg_invest"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-0 px-2 wrap justify-center>
                    <v-flex xs12 sm6 md6 text-center pt-3>
                      <span style="font-size:14px;font-weight:400;">Total Amount at maturity</span>
                    </v-flex>
                    <v-flex xs12 sm6 md6 px-4>
                      <v-text-field
                        ref="subscribtionTotal"
                        v-model="subscribtionTotal"
                        solo
                        style="font-weight:500"
                        readonly
                        prepend-inner-icon="mdi-currency-usd"
                        color="#26af82"
                        dense
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout py-2 px-12 xs8 sm8 md8 wrap justify-space-around>
          <v-flex px-12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout py-2 px-12 xs8 sm8 md8 wrap justify-space-around>
          <v-flex xs12 sm12 md6 text-center pt-4>
            <span style="font-size:24px;font-weight:600;">Terms and Conditions</span>
          </v-flex>
        </v-layout>
        <v-layout v-for="(item,i) in termsandconditions" :key="i">
          <v-flex>
            <v-layout wrap justify-space-around>
              <v-flex xs12 sm12 md6 text-left pt-2 px-2>
                <span style="font-size:16px;font-weight:500;">{{item.title}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-around>
              <v-flex xs12 sm12 md6 text-justify pt-2 px-2>
                <span style="font-size:14px;font-weight:400;">{{item.body}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-around>
              <v-flex xs12 sm12 md6 text-left pt-2 px-2>
                <v-btn
                  small
                  :ripple="false"
                  class="text-capitalize"
                  outlined
                  :color="item.accepted?'#00A972' : '#cecece'"
                  width="120"
                  @click="termsaccept(item._id)"
                >
                  <span v-if="item.accepted">Accepted</span>
                  <span v-else>Accept</span>
                  <v-img
                    v-if="item.accepted"
                    src="../../assets/icons/tick.png"
                    aspect-ratio="1"
                    contain
                    height="16px"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout py-4 px-12 xs8 sm8 md8 wrap justify-space-around>
              <v-flex px-12>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-around>
          <v-flex xs12 sm12 md6 text-center pt-2 px-2>
            <span
              style="font-size:16px;font-weight:500;"
            >Please contact us if you require clarification on any points.</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-around pb-12>
          <v-flex xs12 sm12 md6 text-center pt-2 px-2>
            <v-btn
              small
              :ripple="false"
              id="sup_front"
              class="text-capitalize"
              dark
              width="220"
              :color="disableSubmit?'#cecece' : '#00A972'"
              @click="submit"
            >Confirm Transaction</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <AppSuccess v-bind:successData="successData" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import AppSuccess from "./../Common/AppSuccess";

export default {
  props: ["id"],
  components: {
    AppSuccess
  },
  data() {
    return {
      AppSuccessInvest: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      appLoading: false,
      dataretrived: false,
      bank: null,
      accountHolder: null,
      accountNo: null,
      bankCode: null,
      branch: null,
      subscribtion: [],
      subscribtionTotal: 0,
      investmentTotal: 0,
      projectData: null,
      termsandconditions: [],
      termaccepted: false,
      noSubSelected: true,
      successData: {},
      disableSubmit: true,
      banks: [],
      bankAccount: null,
      mininv: 0,
      maxinv: 0,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters"
      },
      msg_invest: null
    };
  },
  computed: {
    form() {
      return {
        bank: this.bank,
        accountHolder: this.accountHolder,
        accountNo: this.accountNo,
        bankCode: this.bankCode,
        branch: this.branch
      };
    }
  },
  mounted() {
    this.getData();
    this.getBanks();
  },
  watch: {
    subscribtion: {
      handler: function(oldval, newval) {
        if (oldval == newval) {
          // this.appLoading = true;
          axios({
            method: "POST",
            url: "/projectpledge/getmaturity",
            data: {
              security: this.subscribtion
            },
            headers: {
              "x-auth-token": localStorage.getItem("token")
            }
          })
            .then(response => {
              this.appLoading = false;
              for (var i = 0; i < response.data.data.length; i++) {
                this.subscribtion[i].maturity = response.data.data[i].maturity;
              }
              this.subscribtionTotal = response.data.totalMaturity;
              this.investmentTotal = response.data.totalInvested;
              if (this.investmentTotal < this.mininv) {
                this.msg_invest = "Minimum " + this.mininv;
              } else if (this.investmentTotal > this.maxinv) {
                this.msg_invest = "Maximum " + this.maxinv;
              } else {
                this.msg_invest = null;
              }
            })
            .catch(err => {
              this.msg = err;
              this.ServerError = true;
            });
        }
      },
      deep: true
    },
    termsandconditions: {
      handler: function() {
        var flag = false;
        for (var i = 0; i < this.termsandconditions.length; i++) {
          if (!this.termsandconditions[i].accepted) flag = true;
        }
        if (flag) this.disableSubmit = true;
        else this.disableSubmit = false;
      },
      deep: true
    },
    bankAccount: {
      handler: function() {
        this.bank = this.bankAccount.Bank;
        this.accountHolder = this.bankAccount.AccountHolder;
        this.accountNo = this.bankAccount.AccountNumber;
        this.bankCode = this.bankAccount.BankCode;
        this.branch = this.bankAccount.Branch;
      }
    }
  },
  methods: {
    termsaccept(item) {
      for (var i = 0; i < this.termsandconditions.length; i++) {
        if (item == this.termsandconditions[i]._id) {
          this.termsandconditions[i].accepted = !this.termsandconditions[i]
            .accepted;
        }
      }
    },
    getBanks() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/bank/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.msg = response;
          this.banks = response.data.data;
          if (this.banks.length > 0) {
            this.bankAccount = this.banks[0];
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/get",
        params: {
          id: this.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.projectData = response.data.data;
          // this.termsandconditions = this.projectData.termsandconditions;
          this.mininv = this.projectData.minimumReservation;
          this.maxinv = this.projectData.maximumReservation;
          for (var i = 0; i < this.projectData.security.length; i++) {
            this.subscribtion.push({
              name: this.projectData.security[i].name,
              amount: null,
              maturity: 0,
              isSelected: false,
              _id: this.projectData.security[i]._id,
              percentage: this.projectData.security[i].percentage
            });
          }

          for (var j = 0; j < this.projectData.termsandconditions.length; j++) {
            this.termsandconditions.push({
              _id: this.projectData.termsandconditions[j]._id,
              title: this.projectData.termsandconditions[j].title,
              body: this.projectData.termsandconditions[j].body,
              accepted: false
            });
          }
          this.dataretrived = true;
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        if (!this.$refs[f].validate(true)) this.formHasErrors = true;
      });
      for (var i = 0; i < this.termsandconditions.length; i++) {
        if (!this.termsandconditions[i].accepted) this.formHasErrors = true;
      }
      for (var j = 0; j < this.subscribtion.length; j++) {
        if (this.subscribtion[j].isSelected) {
          this.noSubSelected = false;
          if (this.subscribtion[j].amount < 1) this.formHasErrors = true;
        }
      }
      this.invest();
    },
    invest() {
      if (!this.formHasErrors && !this.noSubSelected) {
        this.appLoading = true;
        var pledge = {};
        pledge["termsAndConditions"] = this.termsandconditions;
        pledge["totalValueAtMaturity"] = this.subscribtionTotal;
        pledge["paymentData"] = this.subscribtion;
        pledge["Bank"] = this.bank;
        pledge["AccountHolder"] = this.accountHolder;
        pledge["AccountNumber"] = this.accountNo;
        pledge["BankCode"] = this.bankCode;
        pledge["Branch"] = this.branch;
        pledge["projectId"] = this.projectData._id;
        axios({
          method: "POST",
          url: "/projectpledge/add",
          data: pledge,
          headers: {
            "x-auth-token": localStorage.getItem("token")
          }
        })
          .then(response => {
            this.appLoading = false;
            if (response.data.status) {
              this.successData.msg = response.data.msg;
              this.successData.msg = "Invested Successfully";
              this.AppSuccessInvest = true;
              setTimeout(() => {
                this.$router.push("/ProjectStatus");
              }, 3000);
            } else {
              this.msg = response.data.msg;
              this.showsnackbar = true;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please Validate Input";
        if (this.noSubSelected)
          this.msg = "Please Select Atleast one Subscribtion";
        this.showsnackbar = true;
      }
    }
  }
};
</script>